import React, { useState } from 'react';
import { Box, FlatTextInput, Inscription, LinkButton, ResetIcon } from '@common-fe/common-fe';

import { Plan } from '@/modules/plan/plan.types.ts';
import theme from '@/styles/theme';

import { PlanField, useEditablePlan, usePlanFieldError, usePlansActions } from './hooks/usePlanCodeActions';

interface PlanNameProps {
  defaultPlan?: Plan;
  showError?: boolean;
  isViewMode?: boolean;
  showEditAction?: boolean;
}

const PlanName: React.FC<PlanNameProps> = ({ defaultPlan, showError, isViewMode, showEditAction }) => {
  const [isEditMode, setEditMode] = useState(false);

  const { updateEntityDebounced, resetEntity } = usePlansActions();
  const editablePlan = useEditablePlan(defaultPlan?.id);
  const errorText = usePlanFieldError(defaultPlan?.id, PlanField.PlanName);

  return (
    <>
      <Box direction="row" align="center">
        <Inscription size="large" weight={700} color="textBody">{(isViewMode && !showEditAction) ? defaultPlan?.name : editablePlan?.planName || '-'}</Inscription>
        {
          !isEditMode && showEditAction && (
            <LinkButton
              testId='edit-plan-name'
              linkInlineMode
              style={{ marginLeft: theme.spacings.xxs }}
              onClick={() => setEditMode(true)}
            >
              <Inscription lineHeight="26px">Edit</Inscription>
            </LinkButton>
          )
        }
      </Box>
      {isEditMode && (
        <Box direction="row" margin={{ vertical: 's' }}>
          <Box width="320px" margin={{ right: 's' }}>
            <FlatTextInput
              onChange={(value) => defaultPlan?.id && updateEntityDebounced(defaultPlan?.id, PlanField.PlanName, value)}
              value={editablePlan?.planName}
              testId="plan-name"
              placeholder="Enter Plan name"
              errorText={showError ? errorText : undefined}
            />
          </Box>
          <Box style={{ position: 'relative' }}>
            <ResetIcon
              data-testId="reset-plan-code"
              onClick={() => defaultPlan?.id && resetEntity(defaultPlan?.id, PlanField.PlanName)}
              size="16px"
              color="iconPrimary"
              style={{ position: 'absolute', top: theme.spacings.s, cursor: 'pointer' }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PlanName;
